import React, { useState, useEffect } from 'react';
import Image from 'next/image';
import styles from './ReviewHeader.module.scss';
import { Typography } from '@mui/material';
import LearnMoreDrawer from '../../products/template/learnMoreDrawer/LearnMoreDrawer';
import { Icariin, Resveratrol, Turmeric, Omega3 } from '../../../../src/images';
import imgLoader from '../../../../imgloader';

const ReviewHeader = ({
  content,
  isDarkNav,
  darkContent = false,
  className = '',
  isFullBleedSection,
}) => {
  const [showEvents, setShowEvents] = useState(false);
  const [drawerPosition, setDrawerPosition] = useState('right');
  useEffect(() => {
    const resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        const screenWidth = entry.contentRect.width;
        if (screenWidth < 600) {
          setDrawerPosition('bottom');
        } else {
          setDrawerPosition('right');
        }
      }
    });

    resizeObserver.observe(document.body);

    return () => {
      resizeObserver.disconnect();
    };
  }, []);
  const onClicklearnMore = () => {
    setShowEvents(true);
  };
  const aboutProductContent = [
    {
      altText: 'Icariin Image',
      image: Icariin,
      text: `
        <strong>Icariin</strong> 
        <span>
          is also known as Horny Goat Weed and is traditionally used in
          Chinese medicine. It 
          <a target ="_blank" href="https://pubmed.ncbi.nlm.nih.gov/19501202/">
            promotes bone growth and repair,
          </a> 
          improves blood flow in the body, and supports tissue health
          during everyday wear and tear.
        </span>
      `,
    },
    {
      altText: 'Resveratrol Image',
      image: Resveratrol,
      text: `
        <strong>Resveratrol</strong> 
        <span>
          is a plant-based anti-inflammatory
          <a target ="_blank" href="https://www.news-medical.net/health/What-is-Resveratrol.aspx">
             anti-oxidant
          </a> 
          that supports the body’s normal and natural vascular response and blood vessel health. It also promotes a healthy response to biological stress, including physical activity and exercise.
        </span>
      `,
    },
    {
      altText: 'Turmeric Image',
      image: Turmeric,
      text: `
        <strong>Turmeric</strong> 
        <span>
          contains curcumin, a natural chemical that decreases swelling. By “freeing up” the space around joints, it helps relieve stiff joints and reduce pain during movement. In contrast to
          <a target ="_blank" href="https://www.versusarthritis.org/about-arthritis/complementary-and-alternative-treatments/types-of-complementary-treatments/glucosamine/#:~:text=Glucosamine%20is%20found%20naturally%20in,tendons%2C%20cartilage%20and%20synovial%20fluid.">
          glucosamine
          </a> 
          (a chemical that maintains and “cushions” joints, cartilage, and other building blocks of our bodies), turmeric actively works to reduce swelling and pain
        </span>
      `,
    },
    {
      altText: 'Omega-3 Image',
      image: Omega3,
      text: `
        <strong>Omega-3</strong> 
        <span>
          , also known as fish oil,
          <a target ="_blank" href="https://www.verywellhealth.com/fish-oil-for-arthritis-5092351">
              helps relieve joint pain 
          </a> 
          by blocking various sources of inflammation. They also help promote cardiovascular health and natural healing abilities, as well as improve overall well-being and mood.
        </span>
      `,
    },
  ];
  const AboutIngredients = ({ contentList }) => {
    return (
      <div className={styles.timelineContentWrapper}>
        <div className={styles.timelineContentContainer}>
          <div>
            <Typography variant="h3" color="primary">
              Powered By All Natural Ingredients,{' '}
              <span className={styles.noWrap}>Relief Factor</span> Works
              Alongside You
            </Typography>
          </div>
          <div className={styles.content}>
            <Typography variant="p1" color="primary">
              Relief Factor’s 100% drug-free formula uses icariin, resveratrol,
              turmeric, and omega-3 which activate four different metabolic
              pathways to help your body reduce or eliminate aches and pains.
            </Typography>
          </div>
          {contentList.map((item, index) => (
            <div key={index} className={`${styles.container}`}>
              <div className={styles.ImgContainer}>
                <Image
                  alt={item.altText}
                  layout="fill"
                  src={item.image}
                  loading="eager"
                  objectFit="contain"
                  loader={imgLoader}
                  className={styles.graphImage}
                />
              </div>
              <div
                className={styles.ImgText}
                dangerouslySetInnerHTML={{ __html: item.text }}
              />
            </div>
          ))}
        </div>
      </div>
    );
  };
  return (
    <>
      <LearnMoreDrawer
        showDrawer={showEvents}
        setDrawer={setShowEvents}
        position={drawerPosition}
        content={{
          title: 'How Our Unique Formula Works',
          component: <AboutIngredients contentList={aboutProductContent} />,
        }}
      />
      <div
        className={`${styles.BannerImageContainer} ${className} ${
          isDarkNav ? styles.darkNav : ''
        }`}
      >
        {isFullBleedSection && <div className={styles.blurContainer}></div>}
        <Image
          //   alt={altText}
          src={content?.img?.small}
          layout="fill" // Fill the container
          objectFit="cover" // Maintain aspect ratio and cover the container
          // objectPosition="bottom" // Adjust as needed
          //   loader={imgLoader}
          priority
          placeholder="blur"
          blurDataURL={content?.img?.small}
          className={styles.mobileSliderImage}
        />
        <Image
          src={content?.img?.medium}
          layout="fill"
          objectFit="cover"
          objectPosition="bottom"
          priority
          placeholder="blur"
          blurDataURL={content?.img?.medium}
          className={styles.tapSliderImage}
        />
        <Image
          src={content?.img?.large}
          layout="fill"
          objectFit="cover"
          objectPosition="bottom"
          priority
          placeholder="blur"
          blurDataURL={content?.img?.large}
          className={styles.desktopSliderImage}
        />
        <div className={styles.textContainer}>
          <Typography
            variant="h5"
            color={darkContent ? 'primary.black' : 'primary.white'}
          >
            {content?.subTitle}
          </Typography>
          <Typography
            variant="h1"
            color={darkContent ? 'primary.main' : 'primary.white'}
            className={styles.sloganContent}
            dangerouslySetInnerHTML={{ __html: content?.mainTitle }}
          ></Typography>
          {isFullBleedSection && (
            <div
              className={styles.cardBtn}
              onClick={onClicklearnMore}
              variant="outlined"
            >
              <Typography variant="h5">+ Learn More </Typography>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ReviewHeader;
